import { SxProps, Theme } from "@mui/material";

export const avatarWrapperContainer: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  backgroundColor: "#fff",
  color: "#000",
};

export const avatarWrapper: SxProps<Theme> = {
  position: "relative",
  width: 120,
  height: 120,
  cursor: "pointer",
  "&:hover .upload-button": {
    opacity: 1,
  },
  mb: 4,
};

export const avatar: SxProps<Theme> = {
  width: 120,
  height: 120,
  border: "2px solid #ccc",
};

export const uploadButton: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(0,0,0,0.3)",
  color: "white",
  opacity: 0.9,
  "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
};

export const deleteButton: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(255,0,0,0.3)",
  color: "white",
  opacity: 0.9,
  "&:hover": { backgroundColor: "rgba(255,0,0,0.5)" },
};
